/* ==========================================================================
   SHORTCUTS DATA DICTIONARY (ts/shortcuts-data.ts)
   ========================================================================== */

export interface ShortcutMap {
  [key: string]: string;
}

export const TypeSmartShortcuts: ShortcutMap = {
  'rfp': `Ready for Pickup`,
  'email': `Hi {name},\n\nThank you for reaching out! I'd be happy to help you with your inquiry regarding {topic}.\n\nBest regards,\nAlex Vance | TypeSmart`,
  'thanks': `Thanks so much for your support! We truly appreciate having you with us. Let me know if you need anything else!`,
  'meeting': `Could we set up a quick 15-minute call tomorrow at 2:00 PM EST?\nHere is my calendar link: https://calendly.com/alex-expander`,
  'outreach': `Hey {first_name},\n\nLoved your recent post about {topic}! Would love to connect and share how we're saving 5+ hours a week.`,
};
